import React from 'react';

const BathroomSvg = (props) => (
    <svg
        className="bathroom_svg__eds-icon--bathroom_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bathroom_svg__eds-icon--bathroom_man-base"
            d="M8.8 9.1c-.4-.5-1-.9-1.7-.9s-1.3.3-1.7.9l-3.5 4.7.8.6 2.4-3.2v11h1v-6h2v6h1v-11l2.4 3.2.8-.6-3.5-4.7zm-.7 6.1h-2V10.3c0-.2 0-.4.1-.6l.1-.1c.2-.3.5-.4.8-.4.3 0 .6.1.8.4l.1.2c.1.2.1.3.1.6v4.8z"
        />
        <path
            className="bathroom_svg__eds-icon--bathroom_man-circle"
            d="M7.1 6.8c1.4 0 2.5-1.1 2.5-2.5S8.5 1.8 7.1 1.8 4.6 2.9 4.6 4.3s1.1 2.5 2.5 2.5zm0-4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.6.7-1.4 1.5-1.4z"
        />
        <path
            className="bathroom_svg__eds-icon--bathroom_woman-circle"
            d="M18.1 6.8c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5zm0-4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"
        />
        <path
            className="bathroom_svg__eds-icon--bathroom_woman-base_1_"
            d="M20.3 9.9C20 8.8 19 8.2 18.1 8.2c-.9 0-1.9.6-2.2 1.7l-1.8 6.3h2v6h1v-6h2v6h1v-6h2l-1.8-6.3zm-4.7 5.3l1.3-5.1c.2-.7.7-.9 1.1-.9.4 0 1 .2 1.1.9l1.4 5.1h-4.9z"
        />
    </svg>
);

BathroomSvg.displayName = 'BathroomSvg';
export default BathroomSvg;
